<template>
  <div class="col-12">
    <div class="team-nav mx-auto mt-2 mb-4">
      <button v-if="isSingle" class="btn btn-primary border nav-button" :class="showSkill === 'single' ? 'active' : ''"
              @click="showSkill = 'single'; $store.state.selectedTeamType = 'single'">Einzel
      </button>
      <button v-else-if="isDouble" class="btn btn-primary border nav-button"
              :class="showSkill === 'single' ? 'active' : ''"
              @click="showSkill = 'single'; $store.state.selectedTeamType = 'single'">Individuell
      </button>
      <button v-if="isDouble" class="btn btn-primary border nav-button" :class="showSkill === 'double' ? 'active' : ''"
              @click="showSkill = 'double'; $store.state.selectedTeamType = 'double'">Doppel
      </button>
      <button v-if="isDouble" class="btn btn-primary border nav-button" :class="showSkill === 'mixed' ? 'active' : ''"
              @click="showSkill = 'mixed'; $store.state.selectedTeamType = 'mixed'">Mixed
      </button>
    </div>
    <div class="row">
      <div class="col-lg-6 mb-4">
        <ul class="list-group">
          <li class="list-group-item py-3 bg-light text-success"><a data-toggle="collapse"
                                                                    href="#strengthCollapse"
                                                                    aria-expanded="false"
                                                                    aria-controls="strengthCollapse"
                                                                    role="button">Stärken<i
              v-if="filterPlayerSkills(player, 'strength').length" class="fas fa-caret-down ml-2"></i></a>
            <button v-if="$store.state.user.role_name === 'admin' || $store.state.user.role_name === 'trainer'"
                    class="add-skill-btn btn" v-on:click='showAddStrength()'>
              <i class="fas fa-plus px-1"></i>
            </button>
          </li>
          <span class="strength-collapse collapse" id="strengthCollapse">
                        <li v-for="skill in filterPlayerSkills(player, 'strength')" v-bind:key="skill.id"
                            class="list-group-item d-flex">
                            <skill-item
                                :skill="skill"
                                :player="player"
                                @updateSkill="updateSkill"
                            ></skill-item>
                        </li>
                    </span>
        </ul>
      </div>
      <div class="col-lg-6 mb-4">
        <ul class="list-group">
          <li class="list-group-item py-3 bg-light text-success"><a data-toggle="collapse"
                                                                    href="#recommendationCollapse"
                                                                    aria-expanded="false"
                                                                    aria-controls="recommendationCollapse"
                                                                    role="button">Handlungsempfehlungen<i
              v-if="filterPlayerSkills(player, 'recommendation').length" class="fas fa-caret-down ml-2"></i></a>
            <button v-if="$store.state.user.role_name === 'admin' || $store.state.user.role_name === 'trainer'"
                    class="add-skill-btn btn" v-on:click='showAddRecommendation()'>
              <i class="fas fa-plus px-1"></i>
            </button>
          </li>
          <span class="recommendation-collapse collapse" id="recommendationCollapse">
                        <li v-for="skill in filterPlayerSkills(player, 'recommendation')" v-bind:key="skill.id"
                            class="list-group-item d-flex">
                            <skill-item
                                :skill="skill"
                                :player="player"
                                @updateSkill="updateSkill"
                            ></skill-item>
                        </li>
                    </span>
        </ul>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6 mb-4">
        <ul class="list-group">
          <li class="list-group-item py-3 bg-light text-orange"><a data-toggle="collapse"
                                                                   href="#serveCollapse"
                                                                   aria-expanded="false"
                                                                   aria-controls="serveCollapse"
                                                                   role="button">Aufschlagverhalten
            <i v-if="filterPlayerSkills(player, 'serve').length" class="fas fa-caret-down ml-2"></i></a>
            <button v-if="$store.state.user.role_name === 'admin' || $store.state.user.role_name === 'trainer'"
                    class="add-skill-btn btn" v-on:click='showAddServe()'>
              <i class="fas fa-plus px-1"></i>
            </button>
          </li>
          <span class="serve-collapse collapse" id="serveCollapse">
                        <li v-for="skill in filterPlayerSkills(player, 'serve')" v-bind:key="skill.id"
                            class="list-group-item d-flex">
                            <skill-item
                                :skill="skill"
                                :player="player"
                                @updateSkill="updateSkill"
                            ></skill-item>
                        </li>
                    </span>
        </ul>
      </div>
      <div class="col-lg-6 mb-4">
        <ul class="list-group">
          <li class="list-group-item py-3 bg-light text-orange"><a data-toggle="collapse"
                                                                   href="#returnCollapse"
                                                                   aria-expanded="false"
                                                                   aria-controls="returnCollapse"
                                                                   role="button">Rückschlagverhalten<i
              v-if="filterPlayerSkills(player, 'return').length" class="fas fa-caret-down ml-2"></i></a>
            <button v-if="$store.state.user.role_name === 'admin' || $store.state.user.role_name === 'trainer'"
                    class="add-skill-btn btn" v-on:click='showAddReturn()'>
              <i class="fas fa-plus px-1"></i>
            </button>
          </li>
          <span class="return-collapse collapse" id="returnCollapse">
                        <li v-for="skill in filterPlayerSkills(player, 'return')" v-bind:key="skill.id"
                            class="list-group-item d-flex">
                            <skill-item
                                :skill="skill"
                                :player="player"
                                @updateSkill="updateSkill"
                            ></skill-item>
                        </li>
                    </span>
        </ul>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6 mb-4">
        <ul class="list-group">
          <li class="list-group-item py-3 bg-light text-success"><a data-toggle="collapse" href="#miscCollapse"
                                                                    aria-expanded="false" aria-controls="miscCollapse"
                                                                    role="button">Zusätzliche Information
            <i v-if="filterPlayerSkills(player, 'misc').length" class="fas fa-caret-down ml-2"></i></a>
            <button v-if="$store.state.user.role_name === 'admin' || $store.state.user.role_name === 'trainer'"
                    class="add-skill-btn btn" v-on:click='showAddMisc()'>
              <i class="fas fa-plus px-1"></i>
            </button>
          </li>
          <span class="misc-collapse collapse" id="miscCollapse">
                           <li v-for="skill in filterPlayerSkills(player, 'misc')" v-bind:key="skill.id"
                               class="list-group-item d-flex">
                        <skill-item
                            :skill="skill"
                            :player="player"
                            @updateSkill="updateSkill"
                        ></skill-item>
                    </li>
                    </span>
        </ul>
      </div>
    </div>

    <modal name="add-strength" height="auto" :clickToClose="false" :adaptive="true">
      <div style="padding: 1rem" id="addStrengthForm">
        <div class="close-btn">
          <button @click="hide()">
            ❌
          </button>
        </div>
        <div class="form-group">
          <label>Stärke hinzufügen</label>
        </div>
        <div id="strengthComponent" ref="strengthComponent">
          <div class="row mb-2">
            <div class="col-lg-12">
                            <textarea type="text" class="form-control strengthComponentElement"
                                      placeholder="Stärke eintragen (max. 500 Zeichen)" maxlength="500"></textarea>
            </div>
          </div>
        </div>
        <button type="button" class="btn btn-outline-danger w-100 mb-1"
                v-on:click="removeComponent($refs.strengthComponent)">-
        </button>
        <button type="button" class="btn btn-outline-primary w-100 mb-1"
                v-on:click="addComponent($refs.strengthComponent)">+
        </button>
        <div v-if="showSkill !== 'single'" class="selectAdditionalTeammates mt-2">
          Doppelpartner hinzufügen:
          <ul v-for="team in player.teams" :key="team" class="list-group list-group-flush">
            <li v-if="team.player1_id !== player.id" class="list-group-item">
              <label>
                <input type="checkbox" v-model="teammates"
                       v-bind:value="team.player1_id">
                {{ team.player1.forename }} {{ team.player1.surname }}
              </label>
            </li>
            <li v-else-if="team.player2_id !== null" class="list-group-item">
              <label>
                <input type="checkbox" v-model="teammates"
                       v-bind:value="team.player2_id">
                {{ team.player2.forename }} {{ team.player2.surname }}
              </label>
            </li>
          </ul>
        </div>
        <button class="btn btn-primary add-skill-submit-btn" v-on:click="addSkill('strength')">
          Hinzufügen
        </button>
      </div>
    </modal>

    <modal name="add-serve" height="auto" :clickToClose="false" :adaptive="true">
      <div style="padding: 1rem" id="addServeForm">
        <div class="close-btn">
          <button @click="hide()">
            ❌
          </button>
        </div>
        <div class="form-group">
          <label>Aufschlagverhalten hinzufügen</label>
        </div>
        <div id="serveComponent" ref="serveComponent">
          <div class="row mb-2">
            <div class="col-lg-12">
                        <textarea type="text" class="form-control serveComponentElement"
                                  placeholder="Aufschlagverhalten eintragen (max. 500 Zeichen)"
                                  maxlength="500"></textarea>
            </div>
          </div>
        </div>
        <button type="button" class="btn btn-outline-danger w-100 mb-1"
                v-on:click="removeComponent($refs.serveComponent)">-
        </button>
        <button type="button" class="btn btn-outline-primary w-100 mb-1"
                v-on:click="addComponent($refs.serveComponent)">+
        </button>
        <div v-if="showSkill !== 'single'" class="selectAdditionalTeammates">
          Doppelpartner hinzufügen:
          <ul v-for="team in player.teams" :key="team" class="list-group list-group-flush">
            <li v-if="team.player1_id !== player.id" class="list-group-item">
              <label>
                <input type="checkbox" v-model="teammates"
                       v-bind:value="team.player1_id">
                {{ team.player1.forename }} {{ team.player1.surname }}
              </label>
            </li>
            <li v-else-if="team.player2_id !== null" class="list-group-item">
              <label>
                <input type="checkbox" v-model="teammates"
                       v-bind:value="team.player2_id">
                {{ team.player2.forename }} {{ team.player2.surname }}
              </label>
            </li>
          </ul>
        </div>
        <button class="btn btn-primary add-skill-submit-btn" v-on:click="addSkill('serve')">
          Hinzufügen
        </button>
      </div>
    </modal>

    <modal name="add-recommendation" height="auto" :clickToClose="false" :adaptive="true">
      <div style="padding: 1rem" id="addRecommendationForm">
        <div class="close-btn">
          <button @click="hide()">
            ❌
          </button>
        </div>
        <div class="form-group">
          <label>Handlungsempfehlung hinzufügen</label>
        </div>
        <div id="recommendationComponent" ref="recommendationComponent">
          <div class="row mb-2">
            <div class="col-lg-12">
                            <textarea type="text" class="form-control recommendationComponentElement"
                                      placeholder="Handlungsempfehlung eintragen (max. 500 Zeichen)"
                                      maxlength="500"></textarea>
            </div>
          </div>
        </div>
        <button type="button" class="btn btn-outline-danger w-100 mb-1"
                v-on:click="removeComponent($refs.recommendationComponent)">-
        </button>
        <button type="button" class="btn btn-outline-primary w-100 mb-1"
                v-on:click="addComponent($refs.recommendationComponent)">+
        </button>
        <div v-if="showSkill !== 'single'" class="selectAdditionalTeammates">
          Doppelpartner hinzufügen:
          <ul v-for="team in player.teams" :key="team" class="list-group list-group-flush">
            <li v-if="team.player1_id !== player.id" class="list-group-item">
              <label>
                <input type="checkbox" v-model="teammates"
                       v-bind:value="team.player1_id">
                {{ team.player1.forename }} {{ team.player1.surname }}
              </label>
            </li>
            <li v-else-if="team.player2_id !== null" class="list-group-item">
              <label>
                <input type="checkbox" v-model="teammates"
                       v-bind:value="team.player2_id">
                {{ team.player2.forename }} {{ team.player2.surname }}
              </label>
            </li>
          </ul>
        </div>
        <button class="btn btn-primary add-skill-submit-btn" v-on:click="addSkill('recommendation')">
          Hinzufügen
        </button>
      </div>
    </modal>

    <modal name="add-return" height="auto" :clickToClose="false" :adaptive="true">
      <div style="padding: 1rem" id="addReturnForm">
        <div class="close-btn">
          <button @click="hide()">
            ❌
          </button>
        </div>
        <div class="form-group">
          <label>Rückschlagverhalten hinzufügen</label>
        </div>
        <div id="returnComponent" ref="returnComponent">
          <div class="row mb-2">
            <div class="col-lg-12">
                            <textarea type="text" class="form-control returnComponentElement"
                                      placeholder="Rückschlagverhalten eintragen (max. 500 Zeichen)"
                                      maxlength="500"></textarea>
            </div>
          </div>
        </div>
        <button type="button" class="btn btn-outline-danger w-100 mb-1"
                v-on:click="removeComponent($refs.returnComponent)">-
        </button>
        <button type="button" class="btn btn-outline-primary w-100 mb-1"
                v-on:click="addComponent($refs.returnComponent)">+
        </button>
        <div v-if="showSkill !== 'single'" class="selectAdditionalTeammates">
          Doppelpartner hinzufügen:
          <ul v-for="team in player.teams" :key="team" class="list-group list-group-flush">
            <li v-if="team.player1_id !== player.id" class="list-group-item">
              <label>
                <input type="checkbox" v-model="teammates"
                       v-bind:value="team.player1_id">
                {{ team.player1.forename }} {{ team.player1.surname }}
              </label>
            </li>
            <li v-else-if="team.player2_id !== null" class="list-group-item">
              <label>
                <input type="checkbox" v-model="teammates"
                       v-bind:value="team.player2_id">
                {{ team.player2.forename }} {{ team.player2.surname }}
              </label>
            </li>
          </ul>
        </div>
        <button class="btn btn-primary add-skill-submit-btn" v-on:click="addSkill('return')">
          Hinzufügen
        </button>
      </div>
    </modal>
    <modal name="add-misc" height="auto" :clickToClose="false" :adaptive="true">
      <div style="padding: 1rem" id="addMiscForm">
        <div class="close-btn">
          <button @click="hide()">
            ❌
          </button>
        </div>
        <div class="close-btn">
          <button @click="hide()">
            ❌
          </button>
        </div>
        <div class="form-group">
          <label>Zusätzliche Information hinzufügen</label>
        </div>
        <div id="miscComponent" ref="miscComponent">
          <div class="row mb-2">
            <div class="col-lg-12">
                            <textarea type="text" class="form-control miscComponentElement"
                                      placeholder="Zusätzliche Information eintragen (max. 500 Zeichen)"
                                      maxlength="500"></textarea>
            </div>
          </div>
        </div>
        <button type="button" class="btn btn-outline-danger w-100 mb-1"
                v-on:click="removeComponent($refs.miscComponent)">-
        </button>
        <button type="button" class="btn btn-outline-primary w-100 mb-1"
                v-on:click="addComponent($refs.miscComponent)">+
        </button>
        <div v-if="showSkill !== 'single'" class="selectAdditionalTeammates">
          Doppelpartner hinzufügen
          <ul v-for="team in player.teams" :key="team" class="list-group list-group-flush">
            <li v-if="team.player1_id !== player.id" class="list-group-item">
              <label>
                <input type="checkbox" v-model="teammates"
                       v-bind:value="team.player1_id">
                {{ team.player1.forename }} {{ team.player1.surname }}
              </label>
            </li>
            <li v-else-if="team.player2_id !== null" class="list-group-item">
              <label>
                <input type="checkbox" v-model="teammates"
                       v-bind:value="team.player2_id">
                {{ team.player2.forename }} {{ team.player2.surname }}
              </label>
            </li>
          </ul>
        </div>
        <button class="btn btn-primary add-skill-submit-btn" v-on:click="addSkill('misc')">
          Hinzufügen
        </button>
      </div>
    </modal>
  </div>
</template>

<script>

import SkillItem from "./SkillItem";
import toast from "../../utils/toast";
import {cordovaUtils} from "../../utils/cordovaUtils";

export default {
  name: 'PlayerOverview',
  components: {SkillItem},
  props: ['player'],
  data: function () {
    return {
      teammates: [],
      showSkill: this.$store.state.selectedTeamType,
    }
  },
  methods: {
    filterPlayerSkills(player, type) {
      if (this.showSkill === 'single') {
        let skills = this.singleSkills.filter(skill => skill.type === type);
        for (let key in skills) {
          try {
            let json = JSON.parse(skills[key].text);
            skills[key]["subskills"] = json.length > 1 ? json : null;
          } catch {
            skills[key]["subskills"] = null;
          }
        }
        return skills.reverse();
      } else if (this.showSkill === 'double') {
        let skills = this.doubleSkills.filter(skill => skill.type === type);
        this.groupSkillsByTeammate(skills);
        for (let key in skills) {
          try {
            let json = JSON.parse(skills[key].text);
            skills[key]["subskills"] = json.length > 1 ? json : null;
          } catch {
            skills[key]["subskills"] = null;
          }
        }
        return skills;
      } else {
        let skills = this.mixedSkills.filter(skill => skill.type === type);
        this.groupSkillsByTeammate(skills);
        for (let key in skills) {
          try {
            let json = JSON.parse(skills[key].text);
            skills[key]["subskills"] = json.length > 1 ? json : null;
          } catch {
            skills[key]["subskills"] = null;
          }
        }
        return skills;
      }
    },
    showAddStrength() {
      if (cordovaUtils.isOfflineCancel()) {
        return 0;
      }
      this.$modal.show('add-strength', {});
    },
    showAddServe() {
      if (cordovaUtils.isOfflineCancel()) {
        return 0;
      }
      this.$modal.show('add-serve', {});
    },
    showAddRecommendation() {
      if (cordovaUtils.isOfflineCancel()) {
        return 0;
      }
      this.$modal.show('add-recommendation', {});
    },
    showAddReturn() {
      if (cordovaUtils.isOfflineCancel()) {
        return 0;
      }
      this.$modal.show('add-return', {});
    },
    showAddMisc() {
      if (cordovaUtils.isOfflineCancel()) {
        return 0;
      }
      if (cordovaUtils.isOfflineCancel()) {
        return 0;
      }
      this.$modal.show('add-misc', {});
    },
    hide() {
      this.$modal.hide('add-strength');
      this.$modal.hide('add-serve');
      this.$modal.hide('add-recommendation');
      this.$modal.hide('add-return');
      this.$modal.hide('add-misc');
    },
    addComponent(component) {
      let input = document.createElement("textarea");
      input.setAttribute("type", "text");
      input.setAttribute("placeholder", "Eintragen");
      input.setAttribute("maxlength", "500");
      input.classList.add(component.id + 'Element');
      input.classList.add(component.id + 'Element');
      input.classList.add("form-control");
      let col = document.createElement("div");
      col.classList.add("col-lg-12");
      col.appendChild(input);
      let row = document.createElement("div");
      row.classList.add("row");
      row.classList.add("mb-2");
      row.appendChild(col);
      component.appendChild(row);
    },
    removeComponent(component) {
      if (component.children.length > 1) {
        component.lastChild.remove()
      }
    },
    addSkill(type) {
      let text = '';
      if (this.showSkill !== 'single' && !this.teammates.length) {
        toast.error('Bitte Partner auswählen');
        return;
      }
      switch (type) {
        case 'strength':
          // eslint-disable-next-line no-case-declarations
          let strengthComponents = document.getElementById('addStrengthForm').getElementsByClassName('strengthComponentElement');
          // eslint-disable-next-line no-case-declarations
          let strengthComponentsArray = [];

          for (let i = 0; i < strengthComponents.length; i++) {
            let component = strengthComponents[i].value.trim();
            if (component && component.length <= 500) {
              strengthComponentsArray.push(component);
            } else {
              toast.error('Titel maximal 500 Zeichen');
              return;
            }
          }

          if (strengthComponentsArray.length > 0) {
            if (strengthComponentsArray.length === 1) {
              text = strengthComponentsArray[0];
            } else {
              text = JSON.stringify(strengthComponentsArray);
            }
          }
          break;
        case 'serve':
          // eslint-disable-next-line no-case-declarations
          let serveComponents = document.getElementById('addServeForm').getElementsByClassName('serveComponentElement');
          // eslint-disable-next-line no-case-declarations
          let serveComponentsArray = [];

          for (let i = 0; i < serveComponents.length; i++) {
            let component = serveComponents[i].value.trim();
            if (component && component.length <= 500) {
              serveComponentsArray.push(component);
            } else {
              toast.error('Titel maximal 500 Zeichen');
              return;
            }
          }

          if (serveComponentsArray.length > 0) {
            if (serveComponentsArray.length === 1) {
              text = serveComponentsArray[0];
            } else {
              text = JSON.stringify(serveComponentsArray);
            }
          }
          break;
        case 'recommendation':
          // eslint-disable-next-line no-case-declarations
          let recommendationComponents = document.getElementById('addRecommendationForm').getElementsByClassName('recommendationComponentElement');
          // eslint-disable-next-line no-case-declarations
          let recommendationComponentsArray = [];
          for (let i = 0; i < recommendationComponents.length; i++) {
            let component = recommendationComponents[i].value.trim();
            if (component && component.length <= 500) {
              recommendationComponentsArray.push(component);
            } else {
              toast.error('Titel maximal 500 Zeichen');
              return;
            }
          }

          if (recommendationComponentsArray.length > 0) {
            if (recommendationComponentsArray.length === 1) {
              text = recommendationComponentsArray[0];
            } else {
              text = JSON.stringify(recommendationComponentsArray);
            }
          }
          break;
        case 'return':
          // eslint-disable-next-line no-case-declarations
          let returnComponents = document.getElementById('addReturnForm').getElementsByClassName('returnComponentElement');
          // eslint-disable-next-line no-case-declarations
          let returnComponentsArray = [];
          for (let i = 0; i < returnComponents.length; i++) {
            let component = returnComponents[i].value.trim();
            if (component && component.length <= 500) {
              returnComponentsArray.push(component);
            } else {
              toast.error('Titel maximal 500 Zeichen');
              return;
            }
          }

          if (returnComponentsArray.length > 0) {
            if (returnComponentsArray.length === 1) {
              text = returnComponentsArray[0];
            } else {
              text = JSON.stringify(returnComponentsArray);
            }
          }
          break;
        case 'misc':
          // eslint-disable-next-line no-case-declarations
          let miscComponents = document.getElementById('addMiscForm').getElementsByClassName('miscComponentElement');
          // eslint-disable-next-line no-case-declarations
          let miscComponentsArray = [];

          for (let i = 0; i < miscComponents.length; i++) {
            let component = miscComponents[i].value.trim();
            if (component && component.length <= 500) {
              miscComponentsArray.push(component);
            } else {
              toast.error('Titel maximal 500 Zeichen');
              return;
            }
          }

          if (miscComponentsArray.length > 0) {
            if (miscComponentsArray.length === 1) {
              text = miscComponentsArray[0];
            } else {
              text = JSON.stringify(miscComponentsArray);
            }
          }
          break;
        default:
          break;
      }

      this.$api.createPlayerSkill({
        segments: {
          id: this.player.id,
        },
        data: {
          type: type,
          text: text,
          teammates: this.teammates
        }
      }).then(response => {
            response.data['videos'] = [],
                // eslint-disable-next-line vue/no-mutating-props
                this.player.skills.push(response.data),
                this.hide()
          },
          this.teammates = []
      );
    },
    updateSkill(updatedSkill) {
      this.$emit('updateSkill', updatedSkill)
    },
    groupSkillsByTeammate(skills) {
      let self = this;
      skills.sort(function (a, b) {
        if (a.players[0].id === self.player.id) {
          if (b.players[0].id === self.player.id) {
            if (a.players[1].surname < b.players[1].surname) {
              return 1;
            } else {
              return -1;
            }
          } else {
            if (a.players[1].surname < b.players[0].surname) {
              return 1;
            } else {
              return -1;
            }
          }
        } else {
          if (b.players[0].id === self.player.id) {
            if (a.players[0].surname < b.players[1].surname) {
              return 1;
            } else {
              return -1;
            }
          } else {
            if (a.players[0].surname < b.players[0].surname) {
              return 1;
            } else {
              return -1;
            }
          }
        }
      });
    },
  },
  computed: {
    singleSkills() {
      let singleSkills = [];
      this.player.skills.forEach(function (skill) {
        if (skill.players.length === 1) {
          singleSkills.push(skill);
        }
      });
      return singleSkills;
    },
    doubleSkills() {
      let doubleSkills = [];
      let self = this;
      this.player.skills.forEach(function (skill) {
        if (skill.players[0].id === self.player.id) {
          if (skill.players.length > 1 && skill.players[1].gender === self.player.gender) {
            doubleSkills.push(skill);
          }
        } else {
          if (skill.players.length > 1 && skill.players[0].gender === self.player.gender) {
            doubleSkills.push(skill);
          }
        }
      });
      return doubleSkills;
    },
    mixedSkills() {
      let mixedSkills = [];
      let self = this;
      this.player.skills.forEach(function (skill) {
        if (skill.players[0].id === self.player.id) {
          if (skill.players.length > 1 && skill.players[1].gender !== self.player.gender) {
            mixedSkills.push(skill);
          }
        } else {
          if (skill.players.length > 1 && skill.players[0].gender !== self.player.gender) {
            mixedSkills.push(skill);
          }
        }
      });
      return mixedSkills;
    },
    isDouble() {
      let isDouble = false;
      let self = this;
      this.player.teams.forEach(function (team) {
        if (team.player1_id === self.player.id && team.player2_id !== null) {
          isDouble = true;
        } else if (team.player2_id === self.player.id) {
          isDouble = true;
        }

      });
      return isDouble;
    },
    isSingle() {
      let isSingle = false;
      this.player.teams.forEach(function (team) {
        if (team.player2_id === null) {
          isSingle = true;
        }
      });
      return isSingle;
    }
  }
}
</script>
